import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { puzzleApi } from '../../utils/api'

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: '#fff',
    padding: '32px',
    maxWidth: '400px',
    width: '100%',
    border: '2px solid var(--color-border)',
    textAlign: 'center',
  },
  title: {
    marginTop: 0,
    marginBottom: '16px',
    fontSize: '1.75rem',
  },
  stats: {
    background: 'var(--color-light)',
    padding: '16px',
    marginBottom: '24px',
  },
  stat: {
    marginBottom: '8px',
  },
  statLabel: {
    color: 'var(--color-muted)',
    marginRight: '8px',
  },
  statValue: {
    fontWeight: '700',
    fontSize: '1.25rem',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  btn: {
    padding: '14px 24px',
    border: '2px solid var(--color-border)',
    background: 'var(--color-primary)',
    color: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '1rem',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'block',
  },
  btnSecondary: {
    background: '#fff',
    color: 'var(--color-primary)',
  },
}

export default function CompletionModal({
  solveTime,
  hintsUsed,
  puzzleId,
  formatTime,
  solverName,
}) {
  const [leaderboardRank, setLeaderboardRank] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchLeaderboard() {
      try {
        const data = await puzzleApi.getLeaderboard(puzzleId)
        if (data.entries && solverName) {
          // Find the user's rank by matching name and time (allowing small tolerance)
          const rank = data.entries.findIndex(entry =>
            entry.solverName === solverName &&
            Math.abs(entry.solveTime - solveTime) < 2
          )
          if (rank !== -1) {
            setLeaderboardRank(rank + 1)
          }
        }
      } catch (err) {
        console.error('Failed to fetch leaderboard:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchLeaderboard()
  }, [puzzleId, solverName, solveTime])

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Congratulations!</h2>
        <p>You solved the puzzle!</p>

        {!loading && leaderboardRank && (
          <p style={{ fontSize: '1.25rem', fontWeight: '700', color: 'var(--color-primary)', margin: '16px 0' }}>
            You placed #{leaderboardRank} on the leaderboard!
          </p>
        )}

        <div style={styles.stats}>
          <div style={styles.stat}>
            <span style={styles.statLabel}>Time:</span>
            <span style={styles.statValue}>{formatTime(solveTime)}</span>
          </div>
          <div style={styles.stat}>
            <span style={styles.statLabel}>Hints Used:</span>
            <span style={styles.statValue}>{hintsUsed}</span>
          </div>
        </div>

        <div style={styles.buttons}>
          <Link
            to={`/puzzle/${puzzleId}/leaderboard`}
            style={styles.btn}
          >
            View Leaderboard
          </Link>
          <Link
            to="/"
            style={{ ...styles.btn, ...styles.btnSecondary }}
          >
            Browse More Puzzles
          </Link>
        </div>
      </div>
    </div>
  )
}
